import { render, staticRenderFns } from "./AtaListagemBotoesAcoes.vue?vue&type=template&id=819c0dc2&scoped=true"
import script from "./AtaListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./AtaListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819c0dc2",
  null
  
)

export default component.exports